import { render, staticRenderFns } from "./KS1.vue?vue&type=template&id=1acd3ac2"
import script from "./KS1.vue?vue&type=script&lang=js"
export * from "./KS1.vue?vue&type=script&lang=js"
import style0 from "./KS1.vue?vue&type=style&index=0&id=1acd3ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports